import { actionTypes } from '../reducer';
import { TAGGABLE_TYPE_COLUMNS } from '../constants';

// Shapes the FilterPanel descriptor list. Kept in a hook so the grid component
// stays about the grid.
export default function useFilters({ filters, dispatch, taggableTypeLabels }) {
  const onChange = (field) => (value) => dispatch({ type: actionTypes.FILTER_CHANGED, field, value });
  const onToggle = (field) => () => dispatch({ type: actionTypes.FILTER_TOGGLED, field });

  return [
    {
      field: 'name',
      locale: 'tag_name',
      type: 'textBox',
      active: filters.active.name,
      value: filters.values.name,
      onChange: onChange('name'),
      onToggle: onToggle('name')
    },
    {
      // `commonSelect`, not `dropDownList` — the latter is not a type FilterPanel
      // renders, and it expects `optionsForSelect` rather than `data`.
      field: 'taggableType',
      locale: 'taggable_type',
      type: 'commonSelect',
      active: filters.active.taggableType,
      value: filters.values.taggableType,
      // CommonSelect (a Kendo DropDownList) reads `{ value, label }` objects via
      // textField="label" / dataItemKey="value" — not [label, value] pairs.
      optionsForSelect: TAGGABLE_TYPE_COLUMNS.map(({ type }) => ({
        value: type,
        label: taggableTypeLabels[type] || type
      })),
      onChange: onChange('taggableType'),
      onToggle: onToggle('taggableType')
    },
    {
      field: 'unusedOnly',
      locale: 'unused_only',
      type: 'checkbox',
      active: filters.active.unusedOnly,
      value: filters.values.unusedOnly,
      onChange: onChange('unusedOnly'),
      onToggle: onToggle('unusedOnly')
    }
  ];
}
